import { merge } from 'lodash'
import { DateTime } from 'luxon'
import { DUMMY_GAD7, DUMMY_PHQ9 } from 'src/participantHistory/autofill/dummyScores'
import { BillingCode } from 'src/participantHistory/intakeNote/billingCodeConstants'
import { IntakeNoteComprehensiveFormType } from './IntakeNoteComprehensiveFormSchema'
import { getDefaultValues } from './initialValues/defaultValues'

const DUMMY_TEXT = 'The quick brown fox jumps over a lazy dog'

export const getDummyIntakeNoteComprehensive = (): IntakeNoteComprehensiveFormType => {
  const today = DateTime.now().startOf('day')

  return merge(getDefaultValues(), {
    date: today.toFormat('yyyy-MM-dd'),
    FIRST_NAME: 'Dummy',
    LAST_NAME: 'Patient',
    MEMBER_ID: '12345678',
    CALL_START_TIME: today.set({ hour: 10 }).toUTC().toISO() ?? '',
    CALL_END_TIME: today.set({ hour: 11 }).toUTC().toISO() ?? '',
    PROVIDER_NAME: 'Dummy Provider',
    LICENSE_TYPE: 'LCSW',
    REASON_FOR_SEEKING_TREATMENT: {
      HEALTH_QUESTIONNAIRE: {
        PHQ9: {
          QUESTION1: DUMMY_PHQ9.PHQ9_QUESTION_1,
          QUESTION2: DUMMY_PHQ9.PHQ9_QUESTION_2,
          QUESTION3: DUMMY_PHQ9.PHQ9_QUESTION_3,
          QUESTION4: DUMMY_PHQ9.PHQ9_QUESTION_4,
          QUESTION5: DUMMY_PHQ9.PHQ9_QUESTION_5,
          QUESTION6: DUMMY_PHQ9.PHQ9_QUESTION_6,
          QUESTION7: DUMMY_PHQ9.PHQ9_QUESTION_7,
          QUESTION8: DUMMY_PHQ9.PHQ9_QUESTION_8,
          QUESTION9: DUMMY_PHQ9.PHQ9_QUESTION_9,
          TOTAL_SCORE: DUMMY_PHQ9.PHQ9_SCORE,
        },
        GAD7: {
          QUESTION1: DUMMY_GAD7.GAD7_QUESTION_1,
          QUESTION2: DUMMY_GAD7.GAD7_QUESTION_2,
          QUESTION3: DUMMY_GAD7.GAD7_QUESTION_3,
          QUESTION4: DUMMY_GAD7.GAD7_QUESTION_4,
          QUESTION5: DUMMY_GAD7.GAD7_QUESTION_5,
          QUESTION6: DUMMY_GAD7.GAD7_QUESTION_6,
          QUESTION7: DUMMY_GAD7.GAD7_QUESTION_7,
          TOTAL_SCORE: DUMMY_GAD7.GAD7_SCORE,
        },
      },
      FUNCTIONAL_IMPAIRMENTS: {
        DIFFICULTY_IN_SLEEP: true,
      },
      NARRATIVE: DUMMY_TEXT,
    },
    RISK_ASSESSMENT: {
      BASE: {
        DENY_SI_SIB_SA_HI: true,
      },
      PROTECTIVE_FACTORS_IDENTIFIED: {
        STRONG_SOCIAL_SUPPORT: true,
      },
      NEXT_STEPS: {
        NO_FURTHER_ASSISTANCE_NEEDED: true,
      },
    },
    BIOPYCHOSOCIAL_EVALUATION: {
      CURRENT_LIVING_SITUATION: DUMMY_TEXT,
    },
    BILLING_CODE: [BillingCode.F10_10],
    CLINICAL_FORMULATION: DUMMY_TEXT,
    CASE_CONCEPTUALIZATION: DUMMY_TEXT,
    ELIGIBILITY: {
      ELIGIBLE_FOR_PROGRAM_ENROLLMENT: true,
    },
    REVIEWED_CONFIDENTIALITY_AND_EXPECTATIONS: true,
  }) as IntakeNoteComprehensiveFormType
}
